export default __webpack_public_path__ + "media/zurb/img/work/wtsbooks/wtsbooks-hero-bg-b0bc36bf4846ccae8455b1710eb50ccb.png";